import { colors } from '@constants/colors';

export const useStyles = () => {
  return {
    header: (isBig = false) => ({
      display: 'flex',
      justifyContent: isBig ? ' start' : 'space-between',
      position: 'relative',
      alignItems: 'start',
      gap: 1,
    }),
    headerText: {
      display: 'flex',
      alignItems: 'center',
      columnGap: 1,
      color: colors.white,
      width: '100%',
      flexGrow: 1,
    },
    text: {
      fontSize: 16,
      fontFamily: 'var(--primary-font-bold)',
      lineHeight: 1,
      width: 'max-content',
      letterSpacing: '-0.04em',
    },
    actions: (isOneAction = true) => ({
      display: 'flex',
      justifyContent: isOneAction ? 'end' : 'space-between',
    }),
    buttonIcon: {
      cursor: 'pointer',
      padding: 0,

      '& svg': {
        height: '12px',
        width: '12px',
      },
    },
    closeIcon: {
      fontSize: 12,
      color: colors.grey_200,
    },
  };
};
